<template>
  <div class="pageBox">
	<Header current='souye' ref="Header"></Header>
	<div style="height:56px;"></div>
	<div class="cener">
		<div class="cener_one">
			<img src="@/assets/null.png" />
		</div>
		<div class="cener_two">
			{{$t('i18n_367')}}
		</div>
		<div class="cener_three">
			{{$t('i18n_368')}}
		</div>
	</div>
	<Footer></Footer>
  </div>
</template>

<script>
	import Header from "@/components/header.vue"
	import Footer from "@/components/footer.vue"
  export default {
    components: {
		Header,
		Footer
    },
    data() {
      return {

      }
    },
    mounted() {
		this.$refs.Header.headerHover=true;
		this.$refs.Header.headerTrue=true;
		
    },
    methods: {

    }
  }
</script>

<style>

</style>
<style scoped lang="scss">
.pageBox{
	display: flex;
	flex-direction: column;
	min-height: 100vh;
	.cener{
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		min-height: 500px;
		.cener_one{
			margin-bottom: 9px;
			img{
				width: 100px;
				height: 100px;
			}
		}
		.cener_two{
			margin-bottom: 17px;
			font-size: 29px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #B2B2B2;
		}
		.cener_three{
			font-size: 23px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #B2B2B2;
		}
	}
}
</style>
